import { useDisclosure } from "@mantine/hooks";
import {
  Drawer,
  Button,
  ScrollArea,
  Box,
  createStyles,
  Text,
  Divider,
  Accordion,
  Select,
  Checkbox,
  Group,
} from "@mantine/core";
import { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { createBilling, getAllBillingModal } from "../../services";
import EditClient from "../../components/ClaimBilling/EditClient";

import { encrypt, showError } from "../../utils";
import { getAllPatients } from "../../services/patient";
import {
  editBillingclient,
  getBillingClient,
} from "../../services/billingclient";
import { RxCross1 } from "react-icons/rx";
import TableLoader from "../TableLoader";

const useStyles = createStyles(() => ({
  drawer: {
    ".mantine-Drawer-content": {
      backgroundColor: "#f5f5f5",
      minWidth: "400px",
      "@media (max-width:400px)": {
        minWidth: "100%",
      },
    },
    ".mantine-Drawer-body": {
      padding: "0px",
    },
  },
  container: {
    margin: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: ".5rem",
  },
  userDetails: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5EA",
    borderWidth: "2px",
    borderStyle: "solid",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  details: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  clientSelect: {
    margin: "0px 0px 10px 0px",
  },
  noteDetails: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  noteContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: ".5rem",
  },
  item: {
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    marginBottom: "8px",
    overflow: "hidden",
    background: "#fff",
    padding: "0px",
  },


  summarytitle : {
    fontSize:'15px',
    fontWeight:'bold',
    color:'#000000' 
  },

  summary:{
    fontSize:'20px',
    fontWeight:'bold',
    color:'#000000',
    display:'flex', 
    justifyContent:'center',
    margin:'auto'
  },

  outcomeBox: {
    display: "flex",
    gap: "1rem",
    backgroundColor: "#FAFAFA",
    padding: "1rem",
    borderRadius: "10px",
    border: "1px solid #E7EBEF",
    marginBottom: "1rem",
    marginTop: "1rem",
  },
  coutcomeItem: {
    display: "flex",
    gap: ".4rem",
    flex: "1",
    flexDirection: "column",
  },
  outcomeNote: {
    backgroundColor: "#FAFAFA",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5E5",
    borderWidth: "2px",
    borderStyle: "solid",
    marginTop: "1rem",
  },
  btns: {
    display: "flex",
    gap: "1rem",
    justifyContent: "space-between",
    marginTop: "22rem",
  },

  mainbox: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "89%",
    margin: "auto",
  },

  text: {
    marginTop: "5px",
    marginLeft: "-21px",
    "@media (max-width:1300px)": {
      fontSize: "13px",
    },
  },

  stepNumberText: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },

  clientInfoCardHdng: {
    "@media (max-width:1300px)": {
      fontSize: "14px",
    },
  },

  clientInfoCardText: {
    "@media (max-width:1300px)": {
      fontSize: "12px",
    },
  },

  clientInfoCardDataParent: {
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
    "@media (max-width:1300px)": {
      gap: "10px",
    },
  },

  accordionbox: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  box: {
    width: "30px",
    height: "30px",
    border: "1px solid #000",
    background: "#D9D9D9",
    color: "#FFF",
  },

  cp: {
    cursor: "pointer",
  },

  addbtn: {
    marginTop: "44px",
    marginBottom: "4px",
    display: "flex",
    justifyContent: "flex-end",
  },
  checkbox: {
    width: "20px",
    height: "20px",
    // borderRadius: "6px",
    // border: "1px solid  #D0D5DD",
    // background: "#FFF",
    marginRight: "10px",

    // ".mantine-1l7xo4v:checked": {
    //   borderRadius: "6px",
    //   border: "1px solid  #009883",
    //   background: "#FAFAFA",
    //   boxShadow: "0px 0px 0px 4px #12B76A",
    //   //   width: "20px",
    //   //     height: "20px",
    // },
  },

  // checked: {
  //   ".mantine-1l7xo4v:checked": {
  //     borderRadius: "6px",
  //     border: "1px solid  #009883",
  //     background: "#FAFAFA",
  //     boxShadow: "0px 0px 0px 4px #12B76A",
  //   },
  // },

  container: {
    padding: "12px 12px 20px 30px",
    borderRadius: "12px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
  },
  searchInputParent: {
    width: "55%",
    margin: "20px auto",
  },

  searchInput: {
    height: "50px",
    borderRadius: "25px",
  },

  searchResultListWrapper: {
    maxHeight: "350px",
    overflowY: "auto",
    marginTop: "16px",
  },

  searchResultList: {
    width: "100%",
    margin: "0 auto",
    borderCollapse: "collapse",
    tableLayout: "fixed",

    "& thead": {
      position: "sticky",
      top: 0,
      backgroundColor: "#fff",
      zIndex: 1,
    },

    "& tbody tr:nth-of-type(odd)": {
      backgroundColor: "#f1f1f1",
    },

    "& tbody tr": {
      td: {
        // width: "18.33%",
        borderTop: "1px solid #868e96",
        padding: "10px 20px",
        fontSize: "14px",
        "& button": {
          padding: "0px",
          backgroundColor: "transparent",
          border: "none",
          cursor: "pointer",
          fontWeight: "700",
        },
      },
      // "& td:nth-of-type(1)": {
      //   width: "30%",
      // },
    },
    "& thead th": {
      fontWeight: 700,
      color: "#868e96",
      textAlign: "start",
      // padding: "16px 20px",
      fontSize: "16px",
      // width: "18.33%",
    },

    "& thead th:nth-child(1)": {
      // width: "21%",
    },
    "& thead th:nth-child(3)": {
      // width: "22%",
    },

    "& thead th:nth-child(4)": {
      // width: "12%",
    },
  },
}));

function BilingDrawer({ title, opened, close, claimData, patientsdata }) {
  const patients = useSelector((state) => state.patient);
  const { allbillingclient } = useSelector((state) => state?.billingclient);
  const { loading } = useSelector((state) => state?.billingclient);
  const { profile } = useSelector((state) => state?.profile);
  const [billingClient, setBillingClient] = useState([]);
  const [claimSummary, setClaimSummarry] = useState(false);

  console.log("patients", patients);

  const { allpayer } = useSelector((state) => state.payer);

  const [value, setValue] = useState(null);
  console.log("🚀 ~ NoteDrawer ~ value:", value);

  const { classes } = useStyles();

  useEffect(() => {
    getBillingClient();
  }, []);

  useEffect(() => {
    if (allbillingclient && allbillingclient?.length > 0) {
      let filteredBillingClient = [];
      allbillingclient.forEach((billing_provider) =>
        billing_provider?.payerId?.forEach((payerid_payer) =>
          payerid_payer?.patients?.forEach(
            (patient) =>
              !filteredBillingClient?.some(
                (payer_clientobj) =>
                  payer_clientobj?.payer === payerid_payer?.payer?.id &&
                  payer_clientobj?.selectedClient?.id === patient?.id
              ) &&
              filteredBillingClient.push({
                selectedClient: patient,
                payer: payerid_payer?.payer?.id,
              })
          )
        )
      );

      setBillingClient([...filteredBillingClient]);
    }
  }, [allbillingclient]);

  // const payersinfos = [
  //   {
  //     payertitle: "Payer Name",
  //     payervalue: "Our Home of Abundance",
  //     idtitle: "Payer ID",
  //     idvalue: "04402",
  //     value: "Our Home of Abundance",
  //     title: "Provider Name",
  //     eintitle: "Payer EIN",
  //     einvalue: "00114321",
  //     outcomeNumber: "1",
  //     outcomeCategory: "Community Living",
  //     metGoal: "Yes",
  //     note: "Create a new module for “Task''. This module allows users to create assisted daily care tasks lists. These tasks are created from a list of task items that are pre-added to the Ogiso system. From these tasks list, any staff with permissions can select and sign which task they completed.",
  //   },
  //   {
  //     payertitle: "Payer Name",
  //     payervalue: "Our Home of Abundance",
  //     idtitle: "Payer ID",
  //     idvalue: "04402",
  //     value: "Our Home of Abundance",
  //     title: "Provider Name",
  //     eintitle: "Payer EIN",
  //     einvalue: "00114321",
  //     outcomeNumber: "2",
  //     outcomeCategory: "Community Living",
  //     metGoal: "Yes",
  //     note: "Create a new module for “Task''. This module allows users to create assisted daily care tasks lists. These tasks are created from a list of task items that are pre-added to the Ogiso system. From these tasks list, any staff with permissions can select and sign which task they completed.",
  //   },
  //   {
  //     payertitle: "Payer Name",
  //     payervalue: "Our Home of Abundance",
  //     idtitle: "Payer ID",
  //     idvalue: "04402",
  //     value: "Our Home of Abundance",
  //     title: "Provider Name",
  //     eintitle: "Payer EIN",
  //     einvalue: "00114321",
  //     outcomeNumber: "3",
  //     outcomeCategory: "Community Living",
  //     metGoal: "Yes",
  //     note: "Create a new module for “Task''. This module allows users to create assisted daily care tasks lists. These tasks are created from a list of task items that are pre-added to the Ogiso system. From these tasks list, any staff with permissions can select and sign which task they completed.",
  //   },
  // ];

  // const [provider, setProvider] = useState(true);
  // const [client, setClient] = useState(false);
  // const [payer, setPayer] = useState(false);

  // const [addProvider, setAddProvider] = useState(false);
  // const [addclient, setAddclient] = useState(false);
  // const [addpayer, setAddpayer] = useState(false);

  const [selectedPatients, setSelectedPatients] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [selectedPayers, setSelectedPayers] = useState([]);

  const [state, setState] = useState({
    provider: false,
    client: false,
    payer: true,
    addProvider: false,
    addClient: false,
    addPayer: false,
  });

  useEffect(() => {
    // getAllPatients(11);
    getAllPatients(1, true, true);
  }, []);

  const handlePatientCheckboxChange = (patientId) => {
    setSelectedPatients(
      (prev) =>
        prev.includes(patientId)
          ? prev.filter((id) => id !== patientId) // Deselect if already selected
          : [...prev, patientId] // Add if not selected
    );
  };

  // For provider checkboxes
  const handleProviderCheckboxChange = (providerId) => {
    setSelectedProviders(
      (prev) =>
        prev.includes(providerId)
          ? prev.filter((id) => id !== providerId) // Deselect if already selected
          : [...prev, providerId] // Add if not selected
    );
  };

  // For payer checkboxes
  // const handlePayerCheckboxChange = (billing_client) => {
  //   setSelectedPayers([...selectedPayers, billing_client]);
  // };

  const handlePayerCheckboxChange = (billing_client) => {
    setSelectedPayers((prevSelectedPayers) => {
      // Check if payer.id is already in the array using `some`
      if (
        prevSelectedPayers.some(
          (selectedPayer) => selectedPayer.id === billing_client.id
        )
      ) {
        // If already selected, remove from the array
        return prevSelectedPayers.filter(
          (selectedPayer) => selectedPayer.id !== billing_client.id
        );
      } else {
        // If not selected, add to the array
        return [...prevSelectedPayers, billing_client];
      }
    });
  };

  const handleClientSelection = (value, payerid) => {
    const selectedClient = patients.allPatients.find(
      (patient) => patient.id === value.id
    );

    if (!selectedClient) return;

    if (
      !billingClient.some(
        (client) =>
          client?.selectedClient?.id === selectedClient?.id &&
          client?.payer === payerid
      )
    ) {
      setBillingClient((prevState) => [
        ...prevState,
        {
          selectedClient,
          payer: payerid,
        },
      ]);
    }
  };

  const handleClientRemove = (payerid_client) => {
    setBillingClient((prevState) =>
      prevState.filter(
        (billing_client) =>
          payerid_client?.selectedClient?.id !==
            billing_client?.selectedClient?.id ||
          payerid_client?.payer !== billing_client?.payer
      )
    );
  };

  const navigate = useNavigate();

  const handleBillingPayerClientsUpdate = async (provider, payer) => {
    try {
      let findBillingClientUpdate = {};
      allbillingclient?.forEach((billing_client) => {
        provider?.id === billing_client?.facilityId?.id &&
          billing_client?.payerId?.forEach((payer_patients_obj) => {
            if (payer_patients_obj?.payer?.id === payer?.id) {
              findBillingClientUpdate = billing_client;
            }
          });
      });
      let finalPayload = {
        facilityId: provider?.id || "",
        admin: profile.user.id,
        id: findBillingClientUpdate?.id,
        payerId: findBillingClientUpdate?.payerId?.map((payerId) => ({
          payer: payerId?.payer?.id,
          patients: billingClient
            ?.filter((payerid_client) => payerid_client?.payer === payer?.id)
            ?.map((patient) => patient?.selectedClient?.id),
        })),
      };
      await editBillingclient(finalPayload);
    } catch (error) {
      console.log("error", error);
    }
  };

  console.log("**********", profile.user.id);
  function validateJsonData(jsondata) {
    const requiredFields = [
      "bill_addr_1",
      "bill_city",
      // "balance_due",
      "bill_name",
      "bill_npi",
      "bill_state",
      "bill_taxid",
      "bill_zip",
      "diag_ref",
      "from_date",
      "place_of_service",
      "proc_code",
      "thru_date",
      "units",
      "claim_form",
      "diag_1",
      "ins_number",
      "pat_addr_1",
      "pat_city",
      "pat_dob",
      "pat_name_f",
      "pat_name_l",
      "pat_sex",
      "payer_name",
      "payerid",
      "pcn",
    ];

    // Function to get the value for a specific field (handle nested fields and arrays)
    function getFieldValue(jsondata, field) {
      const fieldParts = field.split(".");
      let value = jsondata?.claim[0];

      // Loop through each part in the field path to drill down
      for (let part of fieldParts) {
        if (value && value[part] !== undefined) {
          value = value[part];
        } else {
          return undefined;
        }
      }

      return value;
    }

    for (let field of requiredFields) {
      let value;

      if (
        [
          "diag_ref",
          "from_date",
          "place_of_service",
          "proc_code",
          "thru_date",
          "units",
        ].includes(field)
      ) {
        value = jsondata?.claim[0]?.charge[0]?.[field]; // assuming there's always at least one charge object
      } else {
        value = getFieldValue(jsondata, field);
      }

      console.log("Checking field:", field, "Value:", value);

      if (value === undefined || value === null || value === "") {
        showError(`Missing or empty field - ${field}`, 400);
        navigate("/home/billing-claim-form");
      }
    }

    return "Success: All required fields are filled!";
  }

  console.log("billingclient$$$$$$$$$$$$$$$$$", allbillingclient);

  const payersinfo = loading ? (
    <TableLoader />
  ) : (
    allbillingclient?.map((billing_client) =>
      billing_client?.payerId?.map((item, index) => (
        // console.log("item payer", item),
        <Accordion.Item
          key={item?.payer?.id}
          value={String(item?.payer?.id)}
          className={classes.item}
        >
          <Accordion.Control>
            <Box className={classes.accordionbox}>
              <Box>
                <Checkbox
                  className={classes.checkbox}
                  value={item?.payer?.id}
                  checked={selectedPayers.some(
                    (selectedPayer) => selectedPayer.id === billing_client?.id
                  )}
                  onChange={() => handlePayerCheckboxChange(billing_client)}
                  // onChange={() => handlePayerCheckboxChange(item?.payer)}
                />
              </Box>
              <Box>
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "24px",
                  }}
                >
                  <Box>
                    <Text ff={"Inter"} fs={"10px"} fw={"400"} color={"#737373"}>
                      Payer Name
                    </Text>

                    <Text ff={"Inter"} fs={"14px"} fw={"600"} color={"#262626"}>
                      {item?.payer?.payerName}
                    </Text>
                  </Box>

                  <Box>
                    <Text ff={"Inter"} fs={"10px"} fw={"400"} color={"#737373"}>
                      Payer ID
                    </Text>

                    <Text ff={"Inter"} fs={"14px"} fw={"600"} color={"#262626"}>
                      {item?.payer?.payerId}
                    </Text>
                  </Box>

                  <Box>
                    <Text ff={"Inter"} fs={"10px"} fw={"400"} color={"#737373"}>
                      Payer EIN
                    </Text>

                    <Text ff={"Inter"} fs={"14px"} fw={"600"} color={"#262626"}>
                      {item?.payer?.payerEntity}
                    </Text>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Accordion.Control>
          <Accordion.Panel>
            <Divider />
            <Select
              id="billing-type"
              className={classes.clientSelect}
              required
              placeholder="select client"
              data={(patients && patients?.allPatients
                ? patients?.allPatients
                : []
              ).map((item) => ({
                value: item,
                label: item?.name,
              }))}
              onChange={(value) =>
                handleClientSelection(value, item?.payer?.id)
              }
            />
            {billingClient &&
              billingClient.length > 0 &&
              billingClient
                ?.filter(
                  (payerid_client) => payerid_client?.payer === item?.payer?.id
                )
                ?.map((payerid_client) => (
                  <>
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "24px",
                        padding: "15px 20px",
                      }}
                    >
                      <Box>
                        <Text
                          ff={"Inter"}
                          fs={"10px"}
                          fw={"400"}
                          color={"#737373"}
                        >
                          Client Name
                        </Text>

                        <Text
                          ff={"Inter"}
                          fs={"14px"}
                          fw={"600"}
                          color={"#262626"}
                        >
                          {payerid_client?.selectedClient?.form1?.firstName}{" "}
                          {payerid_client?.selectedClient?.form1?.lastName}
                        </Text>
                      </Box>

                      <Box>
                        <Text
                          ff={"Inter"}
                          fs={"10px"}
                          fw={"400"}
                          color={"#737373"}
                        >
                          Gender
                        </Text>

                        <Text
                          ff={"Inter"}
                          fs={"14px"}
                          fw={"600"}
                          color={"#262626"}
                        >
                          {payerid_client?.selectedClient?.form1?.gender}
                        </Text>
                      </Box>

                      <Box>
                        <Text
                          ff={"Inter"}
                          fs={"10px"}
                          fw={"400"}
                          color={"#737373"}
                        >
                          DOB
                        </Text>

                        <Text
                          ff={"Inter"}
                          fs={"14px"}
                          fw={"600"}
                          color={"#262626"}
                        >
                          {payerid_client?.selectedClient?.form1?.dob}
                        </Text>
                      </Box>
                      <RxCross1
                        onClick={() => handleClientRemove(payerid_client)}
                        style={{
                          cursor: "pointer",
                          color: "red",
                        }}
                      />
                    </Box>
                    <Divider />
                  </>
                ))}
            {item?.patients?.length > 0 &&
              billingClient?.find(
                (payerid_client) => payerid_client?.payer === item?.payer?.id
              ) && (
                <>
                  <br />
                  <Button
                    onClick={() =>
                      handleBillingPayerClientsUpdate(
                        billing_client?.facilityId,
                        item?.payer
                      )
                    }
                  >
                    Update
                  </Button>
                </>
              )}
          </Accordion.Panel>
        </Accordion.Item>
      ))
    )
  );

  function formatDate(dateString) {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const todayDate = getCurrentDate();
  console.log(todayDate);

  const stateAbbreviations = {
    Alabama: "AL",
    Alaska: "AK",
    Arizona: "AZ",
    Arkansas: "AR",
    California: "CA",
    Colorado: "CO",
    Connecticut: "CT",
    Delaware: "DE",
    Florida: "FL",
    Georgia: "GA",
    Hawaii: "HI",
    Idaho: "ID",
    Illinois: "IL",
    Indiana: "IN",
    Iowa: "IA",
    Kansas: "KS",
    Kentucky: "KY",
    Louisiana: "LA",
    Maine: "ME",
    Maryland: "MD",
    Massachusetts: "MA",
    Michigan: "MI",
    Minnesota: "MN",
    Mississippi: "MS",
    Missouri: "MO",
    Montana: "MT",
    Nebraska: "NE",
    Nevada: "NV",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    "New York": "NY",
    "North Carolina": "NC",
    "North Dakota": "ND",
    ohio: "OH",
    Oklahoma: "OK",
    Oregon: "OR",
    Pennsylvania: "PA",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    Tennessee: "TN",
    Texas: "TX",
    Utah: "UT",
    Vermont: "VT",
    Virginia: "VA",
    Washington: "WA",
    "West Virginia": "WV",
    Wisconsin: "WI",
    Wyoming: "WY",
  };

  const showSummary = async () => {
    setClaimSummarry(true);
  };

  console.log("selectedPayers", selectedPayers);

  const savebtn = async () => {
    try {
      const billingdata = {
        filename: "",
        file: {},
        facilityId: null,
        patientId: null,
        admin: null,
        createdBy: null,
        billingForm: null,
      };
      let jsondata = {
        fileid: "124",
        claim: [],
      };

      let diagnosisFields = {};

      // selectedPayers?.forEach((billing_client) => {
      //   let claim_ = {};
      //   billing_client?.payerId?.forEach((payer_patients_obj) => {
      //     payer_patients_obj?.patients?.forEach((patient) => {
      //       const nameParts = billing_client?.facilityId?.name?.split(" ");
      //       const prov_name_f = nameParts[0] || "";
      //       const prov_name_l = nameParts[1] || "";
      //       let diagnosisArray = patient?.form1?.diagnosis || [];
      //       if (Array.isArray(diagnosisArray) && diagnosisArray.length > 0) {
      //         diagnosisArray.forEach((item, index) => {
      //           const diagField = `diag_${index + 1}`;
      //           diagnosisFields[diagField] = item?.code || null; // Safely accessing the code and assigning it
      //         });
      //       }
      //       claim_ = {
      //         accept_assign: "Y", // permanenr field
      //         auto_accident: "N", // permanenr field
      //         balance_due: "", // important
      //         bill_addr_1: billing_client?.facilityId?.address, //important
      //         bill_city: billing_client?.facilityId?.city, // important
      //         bill_name: billing_client?.facilityId?.name, //important
      //         bill_npi: billing_client?.facilityId?.billingIdentifier.number, // important
      //         bill_phone: billing_client?.facilityId?.phone || "",
      //         bill_state: billing_client?.facilityId?.state
      //           ? stateAbbreviations[billing_client?.facilityId?.state] ||
      //             billing_client?.facilityId?.state
      //           : "",
      //         // bill_state: providerId?.state, // important
      //         bill_taxid: billing_client?.facilityId?.federalTaxID?.number, // important
      //         // bill_taxid_type: providerId?.federalTaxID?.type, // important
      //         bill_taxid_type:
      //           billing_client?.facilityId?.federalTaxID?.type === "EIN"
      //             ? "E"
      //             : "S",
      //         bill_zip: billing_client?.facilityId?.zipcode, // important
      //         diagnosis: diagnosisArray,
      //         charge: [
      //           {
      //             charge: patient?.form1?.services?.[0]?.totalCharge || "", // important
      //             charge_record_type: "UN", //patientId?.form1.services[0]?.servicechargeAmount,
      //             diag_ref: "A", // important
      //             from_date: getCurrentDate(), // important
      //             place_of_service:
      //               billing_client?.facilityId?.serviceCode?.code, // important //11
      //             proc_code: billing_client?.facilityId?.serviceCode?.code, // important
      //             remote_chgid: "",
      //             thru_date: getCurrentDate(), // important
      //             // units: patient?.form1?.services?.[0]?.servicechargetype
      //             //   ? patient?.form1?.services?.[0]?.servicechargetype.match(
      //             //       /\d+/
      //             //     )?.[0]
      //             //   : "",
      //             units: "1",
      //           },
      //         ],
      //         claim_form: claimData?.claimId, // important
      //         ...diagnosisFields,
      //         employment_related: "N",
      //         ins_addr_1: patient?.form2?.insurance?.[0]?.address1 || "", // important
      //         ins_city: patient?.form2.insurance?.[0]?.city || "",
      //         ins_dob: patient?.form2.insurance?.[0]?.dob || "",
      //         ins_group: patient?.form2.insurance?.[0]?.groupPolicyNumber || "",
      //         ins_name_f: patient?.form2.insurance?.[0]?.firstName || "",
      //         ins_name_l: patient?.form2.insurance?.[0]?.lastName || "",
      //         ins_number:
      //           patient?.form2.insurance?.[0]?.identificationNumber || "", //important
      //         ins_sex:
      //           patient?.form2?.insurance?.[0]?.gender === "Male" ? "M" : "F",
      //         //ins_state:patientId?.form2.insurance[0].state  || '',
      //         ins_state: patient?.form2?.insurance?.[0]?.state
      //           ? stateAbbreviations[patient.form2.insurance[0]?.state] ||
      //             patient.form2.insurance[0]?.state
      //           : "",
      //         ins_zip: patient?.form2.insurance?.[0]?.zipCode || "",
      //         pat_addr_1: patient?.form1?.previousAddress, // important
      //         pat_city: patient?.form1?.state, // important
      //         pat_dob: formatDate(patient?.form1?.dob), // important
      //         pat_name_f: patient?.form1?.firstName, // important
      //         pat_name_l: patient?.form1?.lastName, // important
      //         pat_rel: "18", // Example, use actual data
      //         pat_sex: patient?.form1?.gender === "Male" ? "M" : "F", // important
      //         // pat_state:patientId?.form1?.state || '',
      //         pat_state: patient?.form1?.state
      //           ? stateAbbreviations[patient.form1?.state] ||
      //             patient.form1?.state
      //           : "",
      //         pat_zip: patient?.form1?.zipCode || "",
      //         payer_addr_1: payer_patients_obj?.payer?.payerAddress1 || "",
      //         payer_city: payer_patients_obj?.payer?.payerCity || "",
      //         payer_name: payer_patients_obj?.payer?.payerName, // important
      //         payer_order: payer_patients_obj?.payer?.payerOrder || "",
      //         payer_state: payer_patients_obj?.payer?.payerState,
      //         payer_zip: payer_patients_obj?.payer?.payerZip,

      //         // payer_state:payerId?.payerState  || '',
      //         // payer_zip: payerId?.payerZip  || '',
      //         payerid: payer_patients_obj?.payer?.payerId, // important
      //         pcn: payer_patients_obj?.payer?.payerEntity, // important
      //         prov_name_f: prov_name_f, // important
      //         prov_name_l: prov_name_l, // important
      //         prov_name_m: billing_client?.facilityId?.name, // important
      //         prov_npi:
      //           billing_client?.facilityId?.billingIdentifier?.number || "",
      //         prov_taxonomy: billing_client?.facilityId?.taxonomy,
      //         ref_name_f: "",
      //         ref_name_l: "",
      //         ref_name_m: "",
      //         ref_npi: "",
      //         remote_batchid: "",
      //         remote_claimid: "",
      //         remote_fileid: "",
      //         total_charge: patient?.form1.services?.[0]?.totalCharge || "", // important
      //       };
      //     });
      //   });
      //   jsondata.claim.push(claim_);
      // });

      selectedPayers?.forEach((billing_client) => {
        billing_client?.payerId?.forEach((payer_patients_obj) => {
          payer_patients_obj?.patients?.forEach((patient) => {
            const nameParts = billing_client?.facilityId?.name?.split(" ");
            const prov_name_f = nameParts[0] || "";
            const prov_name_l = nameParts[1] || "";
      
            let diagnosisFields = {}; // Make sure diagnosisFields is defined
            let diagnosisArray = patient?.form1?.diagnosis || [];
      
            if (Array.isArray(diagnosisArray) && diagnosisArray.length > 0) {
              diagnosisArray.forEach((item, index) => {
                const diagField = `diag_${index + 1}`;
                diagnosisFields[diagField] = item?.code || null; // Safely accessing the code and assigning it
              });
            }
      
            // Only one loop here to create a claim for each patient
            let claim_ = {
              accept_assign: "Y", // permanent field
              auto_accident: "N", // permanent field
              balance_due: "", // important
              bill_addr_1: billing_client?.facilityId?.address, // important
              bill_city: billing_client?.facilityId?.city, // important
              bill_name: billing_client?.facilityId?.name, // important
              bill_npi: billing_client?.facilityId?.billingIdentifier?.number, // important
              bill_phone: billing_client?.facilityId?.phone || "",
              bill_state: billing_client?.facilityId?.state
                ? stateAbbreviations[billing_client?.facilityId?.state] ||
                  billing_client?.facilityId?.state
                : "",
              bill_taxid: billing_client?.facilityId?.federalTaxID?.number, // important
              bill_taxid_type:
                billing_client?.facilityId?.federalTaxID?.type === "EIN"
                  ? "E"
                  : "S",
              bill_zip: billing_client?.facilityId?.zipcode, // important
              diagnosis: diagnosisArray,
              charge: [
                {
                  charge: patient?.form1?.services?.[0]?.totalCharge || "", // important
                  charge_record_type: "UN", // patientId?.form1.services[0]?.servicechargeAmount,
                  diag_ref: "A", // important
                  from_date: getCurrentDate(), // important
                  place_of_service:
                    billing_client?.facilityId?.serviceCode?.code, // important
                  proc_code: billing_client?.facilityId?.serviceCode?.code, // important
                  mod1: patient?.form1?.services?.[0]?.mod1 || "",
                  remote_chgid: "",
                  thru_date: getCurrentDate(), // important
                  units: "1", // units can be changed based on actual data
                },
              ],
              claim_form: claimData?.claimId, // important
              ...diagnosisFields,
              employment_related: "N",
              ins_addr_1: patient?.form2?.insurance?.[0]?.address1 || "", // important
              ins_city: patient?.form2.insurance?.[0]?.city || "",
              ins_dob: patient?.form2.insurance?.[0]?.dob || "",
              ins_group: patient?.form2.insurance?.[0]?.groupPolicyNumber || "",
              ins_name_f: patient?.form2.insurance?.[0]?.firstName || "",
              ins_name_l: patient?.form2.insurance?.[0]?.lastName || "",
              ins_number:
                patient?.form2.insurance?.[0]?.identificationNumber || "", // important
              ins_sex:
                patient?.form2?.insurance?.[0]?.gender === "Male" ? "M" : "F",
              ins_state: patient?.form2?.insurance?.[0]?.state
                ? stateAbbreviations[patient?.form2.insurance[0]?.state] ||
                  patient?.form2.insurance[0]?.state
                : "",
              ins_zip: patient?.form2.insurance?.[0]?.zipCode || "",
              pat_addr_1: patient?.form1?.previousAddress, // important
              pat_city: patient?.form1?.state, // important
              pat_dob: formatDate(patient?.form1?.dob), // important
              pat_name_f: patient?.form1?.firstName, // important
              pat_name_l: patient?.form1?.lastName, // important
              pat_rel: "18", // Example, use actual data
              pat_sex: patient?.form1?.gender === "Male" ? "M" : "F", // important
              pat_state: patient?.form1?.state
                ? stateAbbreviations[patient.form1?.state] ||
                  patient.form1?.state
                : "",
              pat_zip: patient?.form1?.zipCode || "",
              payer_addr_1: payer_patients_obj?.payer?.payerAddress1 || "",
              payer_city: payer_patients_obj?.payer?.payerCity || "",
              payer_name: payer_patients_obj?.payer?.payerName, // important
              payer_order: payer_patients_obj?.payer?.payerOrder || "",
              payer_state: payer_patients_obj?.payer?.payerState,
              payer_zip: payer_patients_obj?.payer?.payerZip,
              payerid: payer_patients_obj?.payer?.payerId, // important
              pcn: payer_patients_obj?.payer?.payerEntity, // important
              prov_name_f: prov_name_f, // important
              prov_name_l: prov_name_l, // important
              prov_name_m: billing_client?.facilityId?.name, // important
              prov_npi:
                billing_client?.facilityId?.billingIdentifier?.number || "",
              prov_taxonomy: billing_client?.facilityId?.taxonomy,
              ref_name_f: "",
              ref_name_l: "",
              ref_name_m: "",
              ref_npi: "",
              remote_batchid: "",
              remote_claimid: "",
              remote_fileid: "",
              total_charge: patient?.form1.services?.[0]?.totalCharge || "", // important
            };
      
            // Push the claim to jsondata.claim
            jsondata.claim.push(claim_);
          });
        });
      });
      
      // Now, jsondata.claim should have multiple claim objects if there are multiple patients in payer_patients_obj.
      
      
      billingdata.filename = "tyy";
      billingdata.file = encrypt(jsondata);
      // billingdata.admin = profile?.user?.id;
      // billingdata.admin = profile?.user?.id;
      // billingdata.createdBy= profile?.user?.admin ?? profile?.user?.id;
        billingdata.createdBy=profile.user.id;
        billingdata.admin=profile?.user?.admin ?? profile?.user?.id;
      billingdata.billingForm = encrypt(jsondata);
      billingdata.admin=profile?.user?.admin ?? profile?.user?.id
      billingdata.createdBy=profile.user.id;
      console.log("jsondata", jsondata);
      console.log("billingDsata", billingdata);
      const res = await createBilling(billingdata);
      if (res === false) {
        close();
        navigate("/home/billing-claim-form");
      }

      await getAllBillingModal({ page: 1 });
      close();
    } catch (e) {
      console.log(e);
      close();
      navigate("/home/billing-claim-form");
    }
    // try {
    //   if (
    //     selectedPatients.length == 0 ||
    //     selectedProviders.length == 0 ||
    //     selectedPayers.length == 0
    //   ) {
    //     showError("fields are missing", 400);
    //     return;
    //   }

    //   if (
    //     selectedPatients.length !== selectedProviders.length ||
    //     selectedPatients.length !== selectedPayers.length
    //   ) {
    //     showError(
    //       "The number of patients, providers, and payers must match.",
    //       400
    //     );
    //     return;
    //   }

    //   const billingdata = {
    //     filename: "",
    //     file: {},
    //     facilityId: null,
    //     patientId: null,
    //     admin: null,
    //     billingForm: null,
    //   };

    //   console.log("selectedPatients", selectedPatients);
    //   console.log("selectedProviders", selectedProviders);
    //   console.log("selectedPayers", selectedPayers);
    //   const jsondata = {
    //     fileid: "124", //important
    //     claim: [],
    //   };
    //   // selectedPatients?.forEach((patientId) => {
    //   //   let claim = {};
    //   //   selectedProviders?.forEach((providerId) => {
    //   //     selectedPayers?.forEach((payerId) => {
    //   //       // const jsondata = {
    //   //       //   "fileid": "124",
    //   //       //   "claim": [
    //   //       //     {
    //   //       //       "accept_assign": "Y",
    //   //       //       "auto_accident": "N",
    //   //       //       "balance_due": "100.00",
    //   //       //       "bill_addr_1": "1234 MEDICAL CENTER DRIVE",
    //   //       //       "bill_city": "SANTA FE",
    //   //       //       "bill_name": "MEDICAL CARE CENTER",
    //   //       //       "bill_npi": "1234567893",
    //   //       //       "bill_phone": "5059999999",
    //   //       //       "bill_state": "NM",
    //   //       //       "bill_taxid": "741111111",
    //   //       //       "bill_taxid_type": "E",
    //   //       //       "bill_zip": "875059998",
    //   //       //       "charge": [
    //   //       //         {
    //   //       //           "charge": "100.00",  // Example, could come from actual data
    //   //       //           "charge_record_type": "UN",  // Example, use actual data
    //   //       //           "diag_ref": "ABCD",  // Example, use actual data
    //   //       //           "from_date": "2022-10-13",  // Example, use actual data
    //   //       //           "place_of_service": "11",  // Example, use actual data
    //   //       //           "proc_code": "99214",  // Example, use actual data
    //   //       //           "remote_chgid": "221043722",  // Example, use actual data
    //   //       //           "thru_date": "2022-10-13",  // Example, use actual data
    //   //       //           "units": "1"  // Example, use actual data
    //   //       //         }
    //   //       //       ],
    //   //       //       "claim_form": claimData?.claimId,  // Example, use actual data
    //   //       //       "diag_1": "J300",  // Example, use actual data
    //   //       //       "diag_2": "K5289",  // Example, use actual data
    //   //       //       "diag_3": "I10",  // Example, use actual data
    //   //       //       "diag_4": "G9331",  // Example, use actual data
    //   //       //       "employment_related": "N",  // Example, use actual data
    //   //       //       "ins_addr_1": "202 COLUMBIA DR NE",  // Example, use actual data
    //   //       //       "ins_city": "ALBUQUERQUE",  // Example, use actual data
    //   //       //       "ins_dob": "1953-07-01",  // Example, use actual data
    //   //       //       "ins_group": "290375",  // Example, use actual data
    //   //       //       "ins_name_f": "JANET",  // Example, use actual data
    //   //       //       "ins_name_l": "IMHOFF",  // Example, use actual data
    //   //       //       "ins_number": "22222933300",  // Example, use actual data
    //   //       //       "ins_sex": "F",  // Example, use actual data
    //   //       //       "ins_state": "NM",  // Example, use actual data
    //   //       //       "ins_zip": "87103",  // Example, use actual data
    //   //       //       "pat_addr_1": patientId?.form1?.address,  // Example, use actual data
    //   //       //       "pat_city": patientId?.form1?.state,  // Example, use actual data
    //   //       //       "pat_dob": patientId?.form1?.dob ? formatDate(patientId.form1.dob) : '',
    //   //       //       "pat_name_f": patientId?.form1?.firstName,  // Example, use actual data
    //   //       //       "pat_name_l": patientId?.form1?.lastName,  // Example, use actual data
    //   //       //       "pat_rel": "18",  // Example, use actual data
    //   //       //      "pat_sex": patientId?.form1?.gender === 'Male' ? 'M' : 'F',  // Example, use actual data
    //   //       //       "pat_state": patientId?.form1?.state,  // Example, use actual data
    //   //       //       "pat_zip": patientId?.form1?.zipCode,  // Example, use actual data
    //   //       //       "payer_addr_1": "P O BOX 660031",
    //   //       //       "payer_city": "DALLAS",
    //   //       //       "payer_name": payerId.payervalue,
    //   //       //       "payer_order": "Primary",
    //   //       //       "payer_state": "TX",
    //   //       //       "payer_zip": "752660031",
    //   //       //       "payerid": payerId?.idvalue,  // Use the payerId from selectedPayers
    //   //       //       "pcn": payerId?.einvalue,  // Example, use actual data
    //   //       //       "prov_name_f": providerId?.providerFirstName,  // Example, use actual data
    //   //       //       "prov_name_l": providerId?.providerLastName,  // Example, use actual data
    //   //       //       "prov_name_m": providerId?.providerName,  // Example, use actual data
    //   //       //       "prov_npi": "1111111112",  // Example, use actual data
    //   //       //       "prov_taxonomy": "208D00000X",  // Example, use actual data
    //   //       //       "ref_name_f": "JASON",  // Example, use actual data
    //   //       //       "ref_name_l": "LUNDGREN MD",  // Example, use actual data
    //   //       //       "ref_name_m": "P",  // Example, use actual data
    //   //       //       "ref_npi": "1231231238",  // Example, use actual data
    //   //       //       "remote_batchid": "2569142",  // Example, use actual data
    //   //       //       "remote_claimid": "199455342",  // Example, use actual data
    //   //       //       "remote_fileid": "000000001",  // Example, use actual data
    //   //       //       "total_charge": "100.00"  // Example, use actual data
    //   //       //     }
    //   //       //   ]
    //   //       // };

    //   //       const nameParts = providerId.name.split(" ");

    //   //       const prov_name_f = nameParts[0] || "";
    //   //       const prov_name_l = nameParts[1] || "";

    //   //       const diagnosisArray = patientId?.form1.diagnosis || []; // Get the diagnosis array (fallback to empty array if not found)

    //   //       // Create an empty object to store dynamic diagnoses
    //   //       const diagnosisFields = {};

    //   //       // diagnosisArray.forEach((item, index) => {
    //   //       //   const diagField = `diag_${index + 1}`;
    //   //       //   diagnosisFields[diagField] = item.code;
    //   //       // });

    //   //       if (Array.isArray(diagnosisArray) && diagnosisArray.length > 0) {
    //   //         diagnosisArray.forEach((item, index) => {
    //   //           const diagField = `diag_${index + 1}`;
    //   //           diagnosisFields[diagField] = item?.code || null; // Safely accessing the code and assigning it
    //   //         });
    //   //       }

    //   //       console.log(
    //   //         "providerId?.services[0]",
    //   //         providerId?.services[0]?.servicechargeNumber
    //   //       );

    //   //       // const jsondata = {
    //   //       //   fileid: "124", //important
    //   //       //   claim: [
    //   //       //     {
    //   //       //       accept_assign: "Y", // permanent field
    //   //       //       auto_accident: "N", // permanent field
    //   //       //       balance_due: "", // important
    //   //       //       bill_addr_1: providerId.address, //important
    //   //       //       bill_city: providerId.city, // important
    //   //       //       bill_name: providerId?.name, //important
    //   //       //       bill_npi: "1245319599", // providerId?.billingIdentifier.number , // important
    //   //       //       bill_phone: providerId?.phone || "",
    //   //       //       bill_state: providerId?.state
    //   //       //         ? stateAbbreviations[providerId.state] || providerId.state
    //   //       //         : "",
    //   //       //       bill_taxid: "124564898", // providerId?.federalTaxID?.number, // important
    //   //       //       bill_taxid_type:
    //   //       //         providerId?.federalTaxID?.type === "EIN" ? "E" : "S", // important
    //   //       //       bill_zip: providerId?.zipcode, // important
    //   //       //       // charge: [
    //   //       //       //   {
    //   //       //       //     charge: patientId?.form1?.services && Array.isArray(patientId.form1.services) && patientId.form1.services.length > 0
    //   //       //       //       ? patientId.form1.services[0]?.totalCharge
    //   //       //       //       : null, // important
    //   //       //       //     charge_record_type: 'UN', // patientId?.form1.services[0]?.servicechargeAmount,
    //   //       //       //     diag_ref: 'A', // important
    //   //       //       //     from_date: getCurrentDate(), // important
    //   //       //       //     place_of_service: providerId?.serviceCode?.code, // important
    //   //       //       //     proc_code: providerId?.procCode?.code, // important
    //   //       //       //     remote_chgid: "",
    //   //       //       //     thru_date: getCurrentDate(), // important
    //   //       //       //     units: patientId?.form1?.services && Array.isArray(patientId.form1.services) && patientId.form1.services.length > 0
    //   //       //       //       ? patientId.form1.services[0]?.servicechargetype?.match(/\d+/)?.[0]
    //   //       //       //       : null, // Check for service charge type
    //   //       //       //   },
    //   //       //       // ],
    //   //       //       charge:
    //   //       //         patientId?.form1?.services &&
    //   //       //         Array.isArray(patientId.form1.services) &&
    //   //       //         patientId.form1.services.length > 0
    //   //       //           ? patientId.form1.services.map((service) => ({
    //   //       //               charge: service?.totalCharge || null,
    //   //       //               charge_record_type: "UN",
    //   //       //               diag_ref: "A",
    //   //       //               from_date: getCurrentDate(),
    //   //       //               place_of_service: providerId?.serviceCode?.code || "",
    //   //       //               proc_code: providerId?.procCode?.code || "",
    //   //       //               remote_chgid: "",
    //   //       //               thru_date: getCurrentDate(),
    //   //       //               units: service?.servicechargetype
    //   //       //                 ? service?.servicechargetype.match(/\d+/)?.[0]
    //   //       //                 : null,
    //   //       //             }))
    //   //       //           : [],

    //   //       //       claim_form: claimData?.claimId,
    //   //       //       ...diagnosisFields,

    //   //       //       employment_related: "N",

    //   //       //       ins_addr_1:
    //   //       //         patientId?.form2?.insurance &&
    //   //       //         Array.isArray(patientId.form2.insurance) &&
    //   //       //         patientId.form2.insurance.length > 0
    //   //       //           ? patientId.form2.insurance[0]?.address1
    //   //       //           : "", // important
    //   //       //       ins_city:
    //   //       //         patientId?.form2?.insurance &&
    //   //       //         Array.isArray(patientId.form2.insurance) &&
    //   //       //         patientId.form2.insurance.length > 0
    //   //       //           ? patientId.form2.insurance[0]?.city
    //   //       //           : "",
    //   //       //       ins_dob:
    //   //       //         patientId?.form2?.insurance &&
    //   //       //         Array.isArray(patientId.form2.insurance) &&
    //   //       //         patientId.form2.insurance.length > 0
    //   //       //           ? formatDate(patientId.form2.insurance[0]?.dob)
    //   //       //           : "",
    //   //       //       ins_group:
    //   //       //         patientId?.form2?.insurance &&
    //   //       //         Array.isArray(patientId.form2.insurance) &&
    //   //       //         patientId.form2.insurance.length > 0
    //   //       //           ? patientId.form2.insurance[0]?.groupPolicyNumber
    //   //       //           : "",
    //   //       //       ins_name_f:
    //   //       //         patientId?.form2?.insurance &&
    //   //       //         Array.isArray(patientId.form2.insurance) &&
    //   //       //         patientId.form2.insurance.length > 0
    //   //       //           ? patientId.form2.insurance[0]?.firstName
    //   //       //           : "",
    //   //       //       ins_name_l:
    //   //       //         patientId?.form2?.insurance &&
    //   //       //         Array.isArray(patientId.form2.insurance) &&
    //   //       //         patientId.form2.insurance.length > 0
    //   //       //           ? patientId.form2.insurance[0]?.lastName
    //   //       //           : "",
    //   //       //       ins_number:
    //   //       //         patientId?.form2?.insurance &&
    //   //       //         Array.isArray(patientId.form2.insurance) &&
    //   //       //         patientId.form2.insurance.length > 0
    //   //       //           ? patientId.form2.insurance[0]?.identificationNumber
    //   //       //           : "", // important
    //   //       //       ins_sex:
    //   //       //         patientId?.form2?.insurance &&
    //   //       //         Array.isArray(patientId.form2.insurance) &&
    //   //       //         patientId.form2.insurance.length > 0
    //   //       //           ? patientId.form2.insurance[0]?.gender === "Male"
    //   //       //             ? "M"
    //   //       //             : "F"
    //   //       //           : "F",
    //   //       //       ins_state:
    //   //       //         patientId?.form2?.insurance &&
    //   //       //         Array.isArray(patientId.form2.insurance) &&
    //   //       //         patientId.form2.insurance.length > 0
    //   //       //           ? patientId.form2.insurance[0]?.state
    //   //       //             ? stateAbbreviations[
    //   //       //                 patientId.form2.insurance[0].state
    //   //       //               ] || patientId.form2.insurance[0].state
    //   //       //             : ""
    //   //       //           : "",
    //   //       //       ins_zip:
    //   //       //         patientId?.form2?.insurance &&
    //   //       //         Array.isArray(patientId.form2.insurance) &&
    //   //       //         patientId.form2.insurance.length > 0
    //   //       //           ? patientId.form2.insurance[0]?.zipCode
    //   //       //           : "",
    //   //       //       pat_addr_1: patientId?.form1?.previousAddress, // important
    //   //       //       pat_city: patientId?.form1?.state, // important
    //   //       //       pat_dob: formatDate(patientId?.form1?.dob), // important
    //   //       //       pat_name_f: patientId?.form1?.firstName, // important
    //   //       //       pat_name_l: patientId?.form1?.lastName, // important
    //   //       //       pat_rel: "18", // Example, use actual data
    //   //       //       pat_sex: patientId?.form1?.gender === "Male" ? "M" : "F", // important
    //   //       //       pat_state: patientId?.form1?.state
    //   //       //         ? stateAbbreviations[patientId.form1.state] ||
    //   //       //           patientId.form1.state
    //   //       //         : "",
    //   //       //       pat_zip: patientId?.form1?.zipCode || "",
    //   //       //       payer_addr_1: payerId?.payerAddress1 || "",
    //   //       //       payer_city: payerId?.payerCity || "",
    //   //       //       payer_name: payerId.payerName, // important
    //   //       //       payer_order: "",
    //   //       //       payer_state:payerId.payerState,
    //   //       //       payer_zip:payerId.payerZip,
    //   //       //       payerid: payerId?.payerId, // important
    //   //       //       pcn: payerId?.payerEntity, // important
    //   //       //       prov_name_f: prov_name_f, // important
    //   //       //       prov_name_l: prov_name_l, // important
    //   //       //       prov_name_m: providerId?.name, // important
    //   //       //       prov_npi: providerId.billingIdentifier.type === "NPI" ? "NPI": "",
    //   //       //       prov_taxonomy:providerId.taxonomy,
    //   //       //       ref_name_f: "",
    //   //       //       ref_name_l: "",
    //   //       //       ref_name_m: "",
    //   //       //       ref_npi: "",
    //   //       //       remote_batchid: "",
    //   //       //       remote_claimid: "",
    //   //       //       remote_fileid: "",
    //   //       //       total_charge:
    //   //       //         patientId?.form1?.services &&
    //   //       //         Array.isArray(patientId.form1.services) &&
    //   //       //         patientId.form1.services.length > 0
    //   //       //           ? patientId.form1.services[0]?.totalCharge
    //   //       //           : null, // important
    //   //       //     },
    //   //       //   ],
    //   //       // };

    //   //       claim = {
    //   //         accept_assign: "Y", // permanent field
    //   //         auto_accident: "N", // permanent field
    //   //         balance_due: "", // important
    //   //         bill_addr_1: providerId.address, //important
    //   //         bill_city: providerId.city, // important
    //   //         bill_name: providerId?.name, //important
    //   //         bill_npi: "1245319599", // providerId?.billingIdentifier.number , // important
    //   //         bill_phone: providerId?.phone || "",
    //   //         bill_state: providerId?.state
    //   //           ? stateAbbreviations[providerId.state] || providerId.state
    //   //           : "",
    //   //         bill_taxid: "124564898", // providerId?.federalTaxID?.number, // important
    //   //         bill_taxid_type:
    //   //           providerId?.federalTaxID?.type === "EIN" ? "E" : "S", // important
    //   //         bill_zip: providerId?.zipcode, // important
    //   //         // charge: [
    //   //         //   {
    //   //         //     charge: patientId?.form1?.services && Array.isArray(patientId.form1.services) && patientId.form1.services.length > 0
    //   //         //       ? patientId.form1.services[0]?.totalCharge
    //   //         //       : null, // important
    //   //         //     charge_record_type: 'UN', // patientId?.form1.services[0]?.servicechargeAmount,
    //   //         //     diag_ref: 'A', // important
    //   //         //     from_date: getCurrentDate(), // important
    //   //         //     place_of_service: providerId?.serviceCode?.code, // important
    //   //         //     proc_code: providerId?.procCode?.code, // important
    //   //         //     remote_chgid: "",
    //   //         //     thru_date: getCurrentDate(), // important
    //   //         //     units: patientId?.form1?.services && Array.isArray(patientId.form1.services) && patientId.form1.services.length > 0
    //   //         //       ? patientId.form1.services[0]?.servicechargetype?.match(/\d+/)?.[0]
    //   //         //       : null, // Check for service charge type
    //   //         //   },
    //   //         // ],
    //   //         charge:
    //   //           patientId?.form1?.services &&
    //   //           Array.isArray(patientId.form1.services) &&
    //   //           patientId.form1.services.length > 0
    //   //             ? patientId.form1.services.map((service) => ({
    //   //                 charge: service?.totalCharge || null,
    //   //                 charge_record_type: "UN",
    //   //                 diag_ref: "A",
    //   //                 from_date: getCurrentDate(),
    //   //                 place_of_service: providerId?.serviceCode?.code || "",
    //   //                 proc_code: providerId?.procCode?.code || "",
    //   //                 remote_chgid: "",
    //   //                 thru_date: getCurrentDate(),
    //   //                 units: service?.servicechargetype
    //   //                   ? service?.servicechargetype.match(/\d+/)?.[0]
    //   //                   : null,
    //   //               }))
    //   //             : [],

    //   //         claim_form: claimData?.claimId,
    //   //         ...diagnosisFields,

    //   //         employment_related: "N",

    //   //         ins_addr_1:
    //   //           patientId?.form2?.insurance &&
    //   //           Array.isArray(patientId.form2.insurance) &&
    //   //           patientId.form2.insurance.length > 0
    //   //             ? patientId.form2.insurance[0]?.address1
    //   //             : "", // important
    //   //         ins_city:
    //   //           patientId?.form2?.insurance &&
    //   //           Array.isArray(patientId.form2.insurance) &&
    //   //           patientId.form2.insurance.length > 0
    //   //             ? patientId.form2.insurance[0]?.city
    //   //             : "",
    //   //         ins_dob:
    //   //           patientId?.form2?.insurance &&
    //   //           Array.isArray(patientId.form2.insurance) &&
    //   //           patientId.form2.insurance.length > 0
    //   //             ? formatDate(patientId.form2.insurance[0]?.dob)
    //   //             : "",
    //   //         ins_group:
    //   //           patientId?.form2?.insurance &&
    //   //           Array.isArray(patientId.form2.insurance) &&
    //   //           patientId.form2.insurance.length > 0
    //   //             ? patientId.form2.insurance[0]?.groupPolicyNumber
    //   //             : "",
    //   //         ins_name_f:
    //   //           patientId?.form2?.insurance &&
    //   //           Array.isArray(patientId.form2.insurance) &&
    //   //           patientId.form2.insurance.length > 0
    //   //             ? patientId.form2.insurance[0]?.firstName
    //   //             : "",
    //   //         ins_name_l:
    //   //           patientId?.form2?.insurance &&
    //   //           Array.isArray(patientId.form2.insurance) &&
    //   //           patientId.form2.insurance.length > 0
    //   //             ? patientId.form2.insurance[0]?.lastName
    //   //             : "",
    //   //         ins_number:
    //   //           patientId?.form2?.insurance &&
    //   //           Array.isArray(patientId.form2.insurance) &&
    //   //           patientId.form2.insurance.length > 0
    //   //             ? patientId.form2.insurance[0]?.identificationNumber
    //   //             : "", // important
    //   //         ins_sex:
    //   //           patientId?.form2?.insurance &&
    //   //           Array.isArray(patientId.form2.insurance) &&
    //   //           patientId.form2.insurance.length > 0
    //   //             ? patientId.form2.insurance[0]?.gender === "Male"
    //   //               ? "M"
    //   //               : "F"
    //   //             : "F",
    //   //         ins_state:
    //   //           patientId?.form2?.insurance &&
    //   //           Array.isArray(patientId.form2.insurance) &&
    //   //           patientId.form2.insurance.length > 0
    //   //             ? patientId.form2.insurance[0]?.state
    //   //               ? stateAbbreviations[patientId.form2.insurance[0].state] ||
    //   //                 patientId.form2.insurance[0].state
    //   //               : ""
    //   //             : "",
    //   //         ins_zip:
    //   //           patientId?.form2?.insurance &&
    //   //           Array.isArray(patientId.form2.insurance) &&
    //   //           patientId.form2.insurance.length > 0
    //   //             ? patientId.form2.insurance[0]?.zipCode
    //   //             : "",
    //   //         pat_addr_1: patientId?.form1?.previousAddress, // important
    //   //         pat_city: patientId?.form1?.state, // important
    //   //         pat_dob: formatDate(patientId?.form1?.dob), // important
    //   //         pat_name_f: patientId?.form1?.firstName, // important
    //   //         pat_name_l: patientId?.form1?.lastName, // important
    //   //         pat_rel: "18", // Example, use actual data
    //   //         pat_sex: patientId?.form1?.gender === "Male" ? "M" : "F", // important
    //   //         pat_state: patientId?.form1?.state
    //   //           ? stateAbbreviations[patientId.form1.state] ||
    //   //             patientId.form1.state
    //   //           : "",
    //   //         pat_zip: patientId?.form1?.zipCode || "",
    //   //         payer_addr_1: payerId?.payerAddress1 || "",
    //   //         payer_city: payerId?.payerCity || "",
    //   //         payer_name: payerId.payerName, // important
    //   //         payer_order: "",
    //   //         payer_state: payerId.payerState,
    //   //         payer_zip: payerId.payerZip,
    //   //         payerid: payerId?.payerId, // important
    //   //         pcn: payerId?.payerEntity, // important
    //   //         prov_name_f: prov_name_f, // important
    //   //         prov_name_l: prov_name_l, // important
    //   //         prov_name_m: providerId?.name, // important
    //   //         prov_npi:
    //   //           providerId?.billingIdentifier?.type === "NPI" ? "NPI" : "",
    //   //         prov_taxonomy: providerId?.taxonomy,
    //   //         ref_name_f: "",
    //   //         ref_name_l: "",
    //   //         ref_name_m: "",
    //   //         ref_npi: "",
    //   //         remote_batchid: "",
    //   //         remote_claimid: "",
    //   //         remote_fileid: "",
    //   //         total_charge:
    //   //           patientId?.form1?.services &&
    //   //           Array.isArray(patientId.form1.services) &&
    //   //           patientId.form1.services.length > 0
    //   //             ? patientId.form1.services[0]?.totalCharge
    //   //             : null, // important
    //   //       };

    //   //       validateJsonData(jsondata);

    //   //       billingdata.filename = patientId?.form1?.middleName;
    //   //       billingdata.file = encrypt(jsondata);
    //   //       billingdata.patientId = patientId.form1.id;
    //   //       billingdata.admin = patientId.admin;
    //   //       billingdata.facilityId = patientId.facilityId.map(
    //   //         (item) => item.id
    //   //       );
    //   //       billingdata.billingForm = encrypt(jsondata);

    //   //       // Now, to push this claim into the billingdata file:

    //   //       // billingdata.file.push(claim);

    //   //       // console.log('claim',claim);
    //   //       console.log("billingdata", billingdata);
    //   //     });
    //   //   });
    //   //   jsondata.claim.push({ ...claim });
    //   // });

    //   console.log("jsondata", jsondata);
    //   //  formData.append("billingdata", JSON.stringify(billingdata));

    //   await createBilling(billingdata);
    //   setSelectedPatients([]);
    //   setSelectedPayers([]);
    //   setSelectedProviders([]);
    //   close();
    // } catch (error) {
    //   console.log("error in sending form", error);
    // }
  };

  const backbtn = () => {
    if (claimSummary === true) {
      setClaimSummarry(false);
    } else {
      close();
    }
  };

  const handleSelection = (type) => {
    if (type === "provider") {
      setState({
        provider: true,
        client: false,
        payer: false,
        addProvider: false,
        addClient: false,
        addPayer: false,
      });
    } else if (type === "client") {
      setState({
        provider: false,
        client: true,
        payer: false,
        addProvider: false,
        addClient: false,
        addPayer: false,
      });
    } else if (type === "payer") {
      setState({
        provider: false,
        client: false,
        payer: true,
        addProvider: false,
        addClient: false,
        addPayer: false,
      });
    }
  };

  return (
    <>
      <Drawer
        offset={8}
        radius="md"
        size="35%"
        zIndex={1200}
        title={title}
        opened={opened}
        onClose={close}
        position="right"
        className={classes.drawer}
        scrollAreaComponent={ScrollArea.Autosize}
        overlayProps={{ backgroundOpacity: 2.5, blur: 4 }}
      >
        <Box className={classes.container}>
          <div className={classes.mainbox}>
            <div
              onClick={() => handleSelection("client")}
              className={classes.cp}
            >
              <div className={classes.box}>
                <Text
                  className={classes.stepNumberText}
                  ff="Inter"
                  fz={16}
                  fw={500}
                  color="#FFF"
                >
                  1
                </Text>
              </div>
              <Text
                className={classes.text}
                ff="Inter"
                fz={16}
                fw={600}
                color={state.client ? "#000" : "#525252"}
              >
                Select Payer
              </Text>
            </div>

            <div className={classes.cp}>
              <div className={classes.box}>
                <Text
                  className={classes.stepNumberText}
                  ff="Inter"
                  fz={16}
                  fw={500}
                  color="#FFF"
                >
                  4
                </Text>
              </div>
              <Text
                className={classes.text}
                ff="Inter"
                fz={16}
                fw={600}
                color="#000"
              >
                Submit Claim
              </Text>
            </div>
          </div>

          <>
            {!claimSummary ? (
              <Box className={classes.outcome}>
                <Accordion
                  defaultValue="Outcome 1"
                  styles={{
                    chevron: {
                      marginLeft: 0,
                    },
                  }}
                >
                  {payersinfo}
                </Accordion>
              </Box>
            ) : (
              <Box className={classes.outcome}>
                <Text     className={classes.summary}>Claim Summary</Text>

                {/* {selectedPayers?.map((payer, payerIndex) =>
                  payer?.payerId?.map((item, itemIndex) => (
                    <p key={itemIndex}>{item?.payer?.payerName}</p>
                  ))
                )} */}

<div className={classes.searchResultListWrapper}>
  <Accordion>
    {selectedPayers?.map((payer, payerIndex) =>
      payer?.payerId?.map((item, itemIndex) =>
        item?.patients?.map((patient, patientIndex) => {

          

    
          const updatedPatient = {
            selectedClient: {
              ...patient, // Spread the entire patient object into selectedClient
            },
          };

          return (
<div>
  {/* Render payer name before the Accordion */}
  <p   className={classes.summarytitle}  key={itemIndex}>{item?.payer?.payerName}</p>

            <Accordion.Item key={patient.id || itemIndex} value={patient.id || itemIndex}>
              <Accordion.Control>
                <Box className={classes.accordionbox}>
                  <Box>
                    <Box className={classes.clientInfoCardDataParent}>
                      {/* Client Info content */}
                      <Box>
                        <Text className={classes.clientInfoCardHdng} ff={"Inter"} fs={"10px"} fw={"400"} color={"#737373"}>
                          Client Name
                        </Text>
                        <Text className={classes.clientInfoCardText} ff={"Inter"} fs={"14px"} fw={"600"} color={"#262626"}>
                          {`${patient?.form1?.firstName} ${patient?.form1?.lastName}`}
                        </Text>
                      </Box>

                      <Box>
                        <Text className={classes.clientInfoCardHdng} ff={"Inter"} fs={"10px"} fw={"400"} color={"#737373"}>
                          Insurance ID
                        </Text>
                        <Text className={classes.clientInfoCardText} ff={"Inter"} fs={"14px"} fw={"600"} color={"#262626"}>
                          {patient?.form2?.insurance[0].identificationNumber}
                        </Text>
                      </Box>

                      <Box>
                        <Text className={classes.clientInfoCardHdng} ff={"Inter"} fs={"10px"} fw={"400"} color={"#737373"}>
                          Service Count
                        </Text>
                        <Text className={classes.clientInfoCardText} ff={"Inter"} fs={"14px"} fw={"600"} color={"#262626"}>
                          {patient?.form1?.services.length}
                        </Text>
                      </Box>

                      <Box>
                        <Text className={classes.clientInfoCardHdng} ff={"Inter"} fs={"10px"} fw={"400"} color={"#737373"}>
                          Service Code
                        </Text>
                        <Text className={classes.clientInfoCardText} ff={"Inter"} fs={"14px"} fw={"600"} color={"#262626"}>
                          {patient?.form1?.services?.map((service) => service?.servicenumber).join(", ")}
                        </Text>
                      </Box>

                      <Box>
                        <Text className={classes.clientInfoCardHdng} ff={"Inter"} fs={"10px"} fw={"400"} color={"#737373"}>
                          Charge Amount
                        </Text>
                        <Text className={classes.clientInfoCardText} ff={"Inter"} fs={"14px"} fw={"600"} color={"#262626"}>
                          {patient?.form1?.services?.reduce(
                            (total, service) => total + (service?.servicechargeAmount || ""),
                            0
                          )}
                        </Text>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Accordion.Control>

              <Accordion.Panel>
                <Divider />
                <EditClient
                  patient={updatedPatient}
                  selectedProvider={patient?.providerId[0]}
                  selectedPayers={selectedPayers}
                  setSelectedPayers={setSelectedPayers}
                  sets
                />
              </Accordion.Panel>
            </Accordion.Item>
            </div>
          );
        })
      )
    )}
  </Accordion>
</div>

              </Box>
            )}
          </>

          <Box className={classes.btns}>
            <Button
              onClick={backbtn}
              variant="white"
              c="#1D2939"
              radius="md"
              size="md"
              color="#FFF"
            >
              Back
            </Button>

            {!claimSummary ? (
              <Button
                 onClick={showSummary}
               // onClick={savebtn}
                variant="filled"
                c="#000"
                radius="md"
                size="md"
                color="yellow"
              >
                Save and Continue
              </Button>
            ) : (
              <Button
                onClick={savebtn}
                variant="filled"
                c="#000"
                radius="md"
                size="md"
                color="yellow"
              >
                Submit Claim
              </Button>
            )}
          </Box>
        </Box>
      </Drawer>

      {/* <EditClient
                    state={editclient}
                    setState={setEditClient}
                    patient={editPatient}
                    // selectedProvider={selectedProviders[0]}
                  /> */}
    </>
  );
}

export default BilingDrawer;
